import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteUsersService = async (userId: string): Promise<void> => {
  await wbsBookingsApi.delete(`/users/${userId}`);
};

export default deleteUsersService;
